import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth';
import { catchError, switchMap, throwError, BehaviorSubject, filter, take } from 'rxjs';

let isRefreshing = false;
let refreshTokenSubject = new BehaviorSubject<any>(null);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  
  // Exclude auth endpoints from interception (they don't need a Bearer token)
  if (req.url.includes('/auth/login') || req.url.includes('/auth/register') || req.url.includes('/auth/refresh')) {
    return next(req);
  }

  const token = authService.getAccessToken();
  let authReq = req;
  
  if (token) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(authReq).pipe(
    catchError((error) => {
      // If 401 Unauthorized, attempt refresh
      if (error instanceof HttpErrorResponse && error.status === 401) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenSubject.next(null);

          return authService.refreshTokens().pipe(
            switchMap((tokens: any) => {
              isRefreshing = false;
              refreshTokenSubject.next(tokens.access_token);
              
              return next(req.clone({
                setHeaders: {
                  Authorization: `Bearer ${tokens.access_token}`
                }
              }));
            }),
            catchError((err) => {
              isRefreshing = false;
              return throwError(() => err);
            })
          );
        } else {
          // If already refreshing, wait for the new token
          return refreshTokenSubject.pipe(
            filter(token => token !== null),
            take(1),
            switchMap(jwt => {
              return next(req.clone({
                setHeaders: {
                  Authorization: `Bearer ${jwt}`
                }
              }));
            })
          );
        }
      }
      return throwError(() => error);
    })
  );
};
